// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"acb17933","346":"2170a9bd","686":"df845c51"}[chunkId] + ".chunk.js";
};